import {
    apiRequest,
    polaKerjaDetail
} from "../../../../../services/adapters/kepegawaian/polaKerjaService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", polaKerjaDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository